export const sprookjes = [
    "Assepoester",
    "Sneeuwwitje",
    "Roodkapje",
    "Doornroosje",
    "Hans en Grietje",
    "Gelaarsde Kat",
    "Rapunzel",
    "Kleine Zeemeermin",
    "Pinokkio",
    "Aladdin",
    "Ali Baba",
    "Boze Heks",
    "Grote Boze Wolf",
    "Tovenaar van Oz",
    "Peter Pan",
    "Kapitein Haak",
    "Tinkerbell",
    "Sprookjesprins",
    "Sprookjesprinses",
    "Reus",
    "Dwergen",
    "Gouden Gans",
    "IJskoningin",
    "Sneeuwkoningin",
    "Zwarte Ridder",
    "Goede Fee",
    "Vliegende Tapijt",
    "Magische Spiegel",
    "Zilveren Slof",
    "Gouden Appel",
    "Magische Bonenstaak",
    "Onzichtbare Mantel",
    "Betoverde Bos",
    "Sprookjesboom",
    "Vuurspuwende Draak",
    "Eenhoorn",
    "Feniks",
    "Zeemeermin",
    "Trol",
    "Elf",
    "Kabouter",
    "Feeënkoningin",
    "Sprookjesverteller"
  ];